import React from 'react';
import { Merchandiser } from '../../../redux/composableDevice/model/Merchandiser.model';
import { ListItem } from '../../../../../theme/components';
import { DeviceSoloIcon } from '../../../../../theme/icons';
import MerchandiserActions from './MerchandiserActions';
import { ViewKey } from '../MerchandiserContainer';

interface MerchandiserSubheaderProps {
  merchandiserId?: string;
  merchandiser?: Merchandiser;
  loading?: boolean;
  moduleSelected: ViewKey;
  onClick?: React.Dispatch<React.SetStateAction<ViewKey>>;
}

export function MerchandiserSubheader(props: MerchandiserSubheaderProps) {
  const { merchandiser, moduleSelected, merchandiserId, loading, onClick } =
    props;
  const subtitle =
    merchandiser?.machineType?.labels?.businessFamily &&
    merchandiser?.machineType?.labels?.businessGroup
      ? `${merchandiser?.machineType?.labels?.businessFamily} - ${merchandiser?.machineType?.labels?.businessGroup}`
      : undefined;

  const image =
    merchandiser?.iconURL ?? merchandiser?.composableDevice?.labels?.imageURL;

  return (
    <ListItem
      id={merchandiserId}
      name={merchandiser?.name ?? ''}
      loading={loading}
      iconURL={image}
      subtitle={subtitle}
      iconNode={!image && <DeviceSoloIcon />}
      buttons={
        <MerchandiserActions
          merchandiserId={merchandiserId}
          moduleSelected={moduleSelected}
          onClick={onClick || (() => {})}
        />
      }
      menuButtons={
        <MerchandiserActions
          merchandiserId={merchandiserId}
          moduleSelected={moduleSelected}
          onClick={onClick || (() => {})}
        />
      }
      ItemContainerProps={{
        disableRipple: true,
        sx: {
          ':hover': { backgroundColor: 'background.container' },
          cursor: 'default',
          px: 3,
          backgroundColor: 'background.container',
        },
      }}
    />
  );
}

export default MerchandiserSubheader;
